import { Button, DatePicker, Drawer, Form, Input, Select } from 'antd';
import React from 'react';

const { Option } = Select;

interface DrawerFormProps {
  visible: boolean;
  title: string;
  form: any;
  onClose: () => void;
  onSubmit: (values: any) => void;
  fields: Array<{
    name: string;
    label: string;
    type: 'input' | 'textarea' | 'select' | 'number' | 'date';
    options?: Array<{ label: string; value: string }>;
    rules?: any[];
  }>;
}

const DrawerForm: React.FC<DrawerFormProps> = ({
  visible,
  title,
  form,
  onClose,
  onSubmit,
  fields,
}) => {
  const handleFinish = (values: any) => {
    onSubmit(values);
    form.resetFields();
    onClose();
  };

  return (
    <Drawer
      title={title}
      width={400}
      visible={visible}
      onClose={onClose}
      bodyStyle={{ paddingBottom: 80 }}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        {fields.map((field) => {
          if (field.type === 'input') {
            return (
              <Form.Item key={field.name} name={field.name} label={field.label} rules={field.rules}>
                <Input placeholder={`Enter ${field.label}`} />
              </Form.Item>
            );
          }
          if (field.type === 'textarea') {
            return (
              <Form.Item key={field.name} name={field.name} label={field.label} rules={field.rules}>
                <Input.TextArea placeholder={`Enter ${field.label}`} />
              </Form.Item>
            );
          }
          if (field.type === 'select') {
            return (
              <Form.Item key={field.name} name={field.name} label={field.label} rules={field.rules}>
                <Select placeholder={`Select ${field.label}`}>
                  {field.options?.map((option) => (
                    <Option key={option.value} value={option.value}>
                      {option.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            );
          }
          if (field.type === 'number') {
            return (
              <Form.Item key={field.name} name={field.name} label={field.label} rules={field.rules}>
                <Input type="number" placeholder={`Enter ${field.label}`} />
              </Form.Item>
            );
          }
          if (field.type === 'date') {
            return (
              <Form.Item key={field.name} name={field.name} label={field.label} rules={field.rules}>
                <DatePicker style={{ width: '100%' }} />
              </Form.Item>
            );
          }
          return null;
        })}
        <Button type="primary" htmlType="submit" block>
          Save
        </Button>
      </Form>
    </Drawer>
  );
};

export default DrawerForm;
